const views = {
 "dashboard.home": require("./views/sections/dashboard.html"),
 "dashboard.merchant": require('./views/sections/merchant-placeholder.html'),
 "dashboard.featured": require('./views/sections/featured-brand-placeholder.html'),
 "dashboard.account": require('./views/sections/account.html'),
 "dashboard.support": require('./views/sections/support.html'),
 "dashboard.terms": require('./views/sections/terms.html')
};

function dashboardConfig($stateProvider, $urlRouterProvider, $httpProvider, ConfigEnvironmentProvider) {
  'ngInject';

  //setting it to false fixes #245. but caching keeps the api from being hammered....
  //@TODO need to tune caching
  $httpProvider.defaults.cache = false; 

  const cdnUrl = ConfigEnvironmentProvider.getConfiguration("cdn");

  const greenback = ConfigEnvironmentProvider.getConfiguration('greenback');

  $stateProvider
    .state('dashboard', {
      url: '/dashboard',
      abstract: true,
      resolve : {
        currentUser: function(AppAuthFactory, Subscriber, $q) {
          var toReturn = $q.defer();
          AppAuthFactory.getCurrentUser(function(err, currentUser) {
            if(err || !currentUser) {
              toReturn.resolve(new Error("Unauthorized"));
            }
            else {
              Subscriber.getSavings({
                "id": currentUser.id,
              }).$promise.then(function(savingsResult) {
                AppAuthFactory.setCurrentUserProperty("savings",savingsResult.savings);
                currentUser.savings = savingsResult.savings
                toReturn.resolve(currentUser);
              }).catch(function(err) {
                toReturn.resolve(err);
              });
            }
          });
          return toReturn.promise;
        }
      },
      views: {
        'main@': {
          template: '<div><div dash-nav-bar></div><div class="db-view" ui-view></div><div access-savings></div></div><div dash-footer></div>',
        }
      },
    })
    .state('dashboard.home', {
      url: '/home',
      templateUrl: views['dashboard.home'],
      controller: function($scope, currentUser, AppAuthFactory) {
        $scope.savings = currentUser.savings;
        $scope.subscriber = currentUser;
        $scope.myCause = currentUser.subscription.cause;
      }
    })
    .state('dashboard.merchant', {
      url: '/merchant',
      templateUrl: views['dashboard.merchant']
    })
    .state('dashboard.featured', {
      url: '/featured',
      templateUrl: views['dashboard.featured']
    })
    .state('dashboard.account', {
      url: '/account',
      resolve: {
        previousSubscriptions: previousSubscriptionsResolver,
        enqueuedSubscriptions: enqueuedSubscriptionsResolver  
      },
      controller: 'accountController',
      templateUrl: views['dashboard.account']
    })
    .state('dashboard.support', {
      url: '/support',
      templateUrl: views['dashboard.support'],
      resolve: {
        faq: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/faq/support.html'
          }).then(function (response) {
            return response.data;
          });
        }
      },
      controller: function($scope, $sce, faq) {
        $scope.faq = $sce.trustAsHtml(faq);
      }
    })
    .state('dashboard.terms', {
      url: '/terms',
      templateUrl: views['dashboard.terms'],
      resolve: {
        terms: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/terms/terms_and_conditions.html'
          }).then(function (response) {
            return response.data;
          });
        },
        eula: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/terms/eula.html'
          }).then(function (response) {
            return response.data;
          });
        },
        privacy: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/terms/privacy.html'
          }).then(function (response) {
            return response.data;
          });
        }
      },
      controller: function($scope, $sce, privacy, eula, terms) {
        $scope.privacy = $sce.trustAsHtml(privacy);
        $scope.eula = $sce.trustAsHtml(eula);
        $scope.terms = $sce.trustAsHtml(terms);
      }
    })
    .state('dashboard.my_cause', {
      url: '/my-cause',
      resolve: {
        cause($stateParams, currentUser, $http){
          const id = currentUser.subscription.cause_id;
          const referred_by = currentUser.subscription.referred_by;
          let subentity = false;
          if( referred_by && referred_by.entity_type == 'cause' ) {
            subentity = currentUser.subscription.subentity_id;
          }
          const config = {
            params: {
              filter:{
                where:{id}
              },
              templating:{
                subentity_id: subentity
              }
            }
          };
          return $http.get(`${greenback}api/causes/findWithSubentity`, config)
            .then((res) => res.data)
            .catch((err) => console.error(err));
        }
      },
      controller($scope, cause, currentUser) {
        $scope.cause = cause;
				ppnClickListener(currentUser);
      },
      template: '<template-delegater cause="cause" entity="cause"></template-delegater>'
    })
    .state('dashboard.partners', {
      url: '/partners',
      resolve: {
        cause($stateParams, currentUser, $http){
          const genericSponsorId = ConfigEnvironmentProvider.getConfiguration("generic_sponsor_id");
          const id = currentUser.subscription.sponsor_id || genericSponsorId;
          const referred_by = currentUser.subscription.referred_by;
          let subentity = false;
          if( referred_by && referred_by.entity_type == 'sponsor' ) {
            subentity = currentUser.subscription.subentity_id;
          }
          const config = {
            params: {
              filter:{
                where:{id}
              },
              templating:{
                subentity_id: subentity
              }
            }
          };
          return $http.get(`${greenback}api/causes/findWithSubentity`, config)
            .then((res) => res.data)
            .catch((err) => console.error(err));
        },
      },
      controller($scope, cause, currentUser) {
        $scope.cause = cause;
				ppnClickListener(currentUser);
      },
      template: '<template-delegater cause="cause" entity="sponsor"></template-delegater>',
    })
    ;

    function ppnClickListener(currentUser) {
			document.addEventListener('click', function(event) {
				var href = event.target.href || '';
				if (href.includes("travel.gogreenback.com")) {
					// Stop the link from redirecting
					event.preventDefault();
					// Redirect instead with JavaScript
					window.location.href = `${href}?refclickid=${currentUser.subscription.primary_entity_id}&refclickid2=${currentUser.subscription.id}&refclickid3=${currentUser.id}`;
				}
			}, false);
    }

    function previousSubscriptionsResolver(Subscription, currentUser)  {
      return Subscription.find({
        "filter": {
          "where": {
            "and": [
              {"subscriber_id": currentUser.id},
              {"expires": {"lte": Date.now()}}
            ]
          },
          "include": ["cause","key","program"]
        }
      }).$promise;
    }

    function enqueuedSubscriptionsResolver(Subscription, currentUser)  {
      return Subscription.find({
        "filter": {
          "where": {
            "and": [
              {"subscriber_id": currentUser.id},
              {"begins": {"gte": Date.now()}}
            ]
          },
          "include": ["cause","key","program"]
        }
      }).$promise;
    }
}

export default dashboardConfig;



// WEBPACK FOOTER //
// ./js/containers/dashboard/dashboard.config.js